import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

/**
 * Hook to read the current workspace plan + quota usage.
 * Consumed by UI gates (PlanLock) and by the Billing usage widget.
 * Refresh is manual via returned `refresh()` so we don't hammer the API.
 */
export function usePlanUsage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/billing/usage");
      setData(r.data);
    } catch {
      // ignore — component should handle null gracefully
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { ...(data || {}), loading, refresh };
}

/** Boolean helper — returns true if the current plan includes the feature. */
export function hasFeature(usage, feature) {
  if (!usage?.limits?.features) return true; // permissive while loading
  return !!usage.limits.features[feature];
}
